import React from 'react'
import hero7 from '@/assets/images/hero-bg/hero-7.jpg'
import { Grid, Container, List, ListItem, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { usePublicLanding } from '@/hooks/usePublicLanding'
import {
  PublicPageHeader,
  PublicPageHero,
} from '@/housefolios-components/PublicPages/layouts'
import PropertySearchDialog from '@/housefolios-components/PublicPages/components/PropertySearchDialog'
import FeatureCard from '@/housefolios-components/PublicPages/components/FeatureCard'
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone'
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone'
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone'
import BusinessCenterTwoToneIcon from '@mui/icons-material/BusinessCenterTwoTone'
import LocalLibraryTwoToneIcon from '@mui/icons-material/LocalLibraryTwoTone'
import GridOnTwoToneIcon from '@mui/icons-material/GridOnTwoTone'

import HamburgerButton from '@/layout-components/HamburgerButton'

export default function PublicLanding() {
  const {
    query,
    setQuery,
    placeResult,
    setPlaceResult,
    open,
    loader,
    setLoader,
    toggleOpen,
    searchProperty,
  } = usePublicLanding()

  const navigation = [
    {
      label: 'Home',
      href: '#/',
      onClick: (e) => e.preventDefault(),
    },
    {
      label: 'Features',
      href: '#/',
      onClick: (e) => e.preventDefault(),
      hasDropdown: true,
      dropdown: (
        <Grid container spacing={0}>
          <Grid size={{ lg: 6 }} sx={{ position: "relative", zIndex: "25" }}>
            <Box sx={[{ backgroundColor: '#fff', borderRadius: '0.65rem', }, { boxShadow: "0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1) !important" }]}>
              <Box sx={[{ px: '1.5rem', textTransform: 'uppercase', pt: '1.5rem', pb: '0.5rem', color: '#368cff', fontWeight: 700, }, { fontSize: "0.875rem !important" }]}>
                Applications
              </Box>
              <List component="div" sx={[{
                width: "100%",
                "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
              }, { flexDirection: 'column', px: '1rem', pb: '1rem', }, {
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#f4772e",
                  background: "rgba(244, 119, 46, 0.05)",
                  "&::before": { background: "#f4772e" },
                },
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { padding: "0.75rem 1.5rem", position: "relative" },
              }]}>
                <ListItem
                  component="a"
                  button
                  href="#/"
                  onClick={(e) => e.preventDefault()}

                  sx={{ px: '1rem' }}
                >
                  <Box sx={{ display: 'flex' }}>
                    <BusinessCenterTwoToneIcon
                      sx={{ color: 'rgba(7, 9, 25, 0.5)' }}
                    />
                    <Box sx={[{ pl: '1rem' }, {
                      color: "#070919",
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                    }]}>
                      <Box sx={{ fontWeight: 700 }}>General</Box>
                      <Box sx={[{ color: 'rgba(7, 9, 25, 0.5)' }, { fontSize: "0.875rem !important" }]}>
                        Multi-purpose user interface for dashboards
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
                <ListItem
                  component="a"
                  button
                  href="#/"
                  onClick={(e) => e.preventDefault()}

                  sx={{ px: '1rem' }}
                >
                  <Box sx={{ display: 'flex' }}>
                    <PeopleAltTwoToneIcon
                      sx={{ color: 'rgba(7, 9, 25, 0.5)' }}
                    />
                    <Box sx={[{ pl: '1rem' }, {
                      color: "#070919",
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                    }]}>
                      <Box sx={{ fontWeight: 700 }}>Messenger</Box>
                      <Box sx={[{ color: 'rgba(7, 9, 25, 0.5)' }, { fontSize: "0.875rem !important" }]}>
                        Niche application UI for building chat windows
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
                <ListItem
                  component="a"
                  button
                  href="#/"
                  onClick={(e) => e.preventDefault()}

                  sx={{ px: '1rem' }}
                >
                  <Box sx={{ display: 'flex' }}>
                    <GridOnTwoToneIcon
                      sx={{ color: 'rgba(7, 9, 25, 0.5)' }}
                    />
                    <Box sx={[{ pl: '1rem' }, {
                      color: "#070919",
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                    }]}>
                      <Box sx={{ fontWeight: 700 }}>Commerce</Box>
                      <Box sx={[{ color: 'rgba(7, 9, 25, 0.5)' }, { fontSize: "0.875rem !important" }]}>
                        Build a commerce related app with this
                        template
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
              </List>
            </Box>
          </Grid>
          <Grid
            size={{ lg: 6 }}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Box sx={[{ width: '100%', p: '1rem' }, { boxShadow: "0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1) !important" }]} style={{ backgroundColor: '#070919', borderTopRightRadius: '0.65rem', borderBottomRightRadius: '0.65rem' }}>
              <List component="div" sx={[{
                width: "100%",
                "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
              }, { flexDirection: 'column', p: 0 }, {
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#f8f9ff",
                  background: "rgba(248, 249, 255, 0.05)",
                  "&::before": { background: "#f8f9ff" },
                },
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { padding: "0.75rem 1.5rem", position: "relative" },
              }]}>
                <ListItem
                  component="a"
                  button
                  href="#/"
                  onClick={(e) => e.preventDefault()}

                  sx={{
                    px: '1rem',
                    color: 'rgba(255, 255, 255, 0.5)',
                  }}
                >
                  <Box sx={{ display: 'flex' }}>
                    <NotificationsActiveTwoToneIcon
                      sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
                    />
                    <Box sx={{ pl: '1rem', color: '#fff' }}>
                      <Box sx={{ fontWeight: 700 }}>Crypto</Box>
                      <Box sx={[{ color: 'rgba(255, 255, 255, 0.5)' }, { fontSize: "0.875rem !important" }]}>
                        User interface inspired by a cryptocurrency
                        exchange
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
                <ListItem
                  component="a"
                  button
                  href="#/"
                  onClick={(e) => e.preventDefault()}

                  sx={{
                    px: '1rem',
                    color: 'rgba(255, 255, 255, 0.5)',
                  }}
                >
                  <Box sx={{ display: 'flex' }}>
                    <LocalLibraryTwoToneIcon
                      sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
                    />
                    <Box sx={{ pl: '1rem', color: '#fff' }}>
                      <Box sx={{ fontWeight: 700 }}>
                        Learning
                        <Box
                          component="span"
                         
                          sx={{
                            display: "inline-block",
                            py: 0,
                            px: "0.7em",
                            fontSize: "70%",
                            fontWeight: 700,
                            lineHeight: "21px",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            verticalAlign: "baseline",
                            borderRadius: "0.2rem",
                            textTransform: "uppercase",
                            height: 20,
                            color: "#fff",
                            backgroundColor: "#11c5db",
                            ml: "1rem",
                          }}
                        >
                          Soon
                        </Box>
                      </Box>
                      <Box sx={[{ color: 'rgba(255, 255, 255, 0.5)' }, { fontSize: "0.875rem !important" }]}>
                        Courses platform template to start development
                        faster
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
                <ListItem
                  component="a"
                  button
                  href="#/"
                  onClick={(e) => e.preventDefault()}

                  sx={{
                    px: '1rem',
                    color: 'rgba(255, 255, 255, 0.5)',
                  }}
                >
                  <Box sx={{ display: 'flex' }}>
                    <SettingsTwoToneIcon
                      sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
                    />
                    <Box sx={{ pl: '1rem', color: '#fff' }}>
                      <Box sx={{ fontWeight: 700 }}>
                        Banking
                        <Box
                          component="span"
                         
                          sx={{
                            display: "inline-block",
                            py: 0,
                            px: "0.7em",
                            fontSize: "70%",
                            fontWeight: 700,
                            lineHeight: "21px",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            verticalAlign: "baseline",
                            borderRadius: "0.2rem",
                            textTransform: "uppercase",
                            height: 20,
                            color: "#fff",
                            backgroundColor: "#11c5db",
                            ml: "1rem",
                          }}
                        >
                          Soon
                        </Box>
                      </Box>
                      <Box sx={[{ color: 'rgba(255, 255, 255, 0.5)' }, { fontSize: "0.875rem !important" }]}>
                        Financial dashboard template inspired by
                        banking apps
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
              </List>
            </Box>
          </Grid>
        </Grid>
      ),
    },
    {
      label: 'Pricing',
      href: '#/',
      onClick: (e) => e.preventDefault(),
    },
  ]

  const actions = [
    {
      sx: {
        display: 'none',
        '@media (min-width: 1100px)': { display: 'block' },
      },
      component: (
        <Box component="button" href="#/" onClick={(e) => e.preventDefault()} sx={[{ textTransform: 'uppercase', fontWeight: 700, whiteSpace: 'nowrap', }, { fontSize: "0.8333333333rem !important", boxShadow: "0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1) !important" }]}>
          Start Trial
        </Box>
      ),
    },
    {
      sx: {
        display: 'block',
        '@media (min-width: 1100px)': { display: 'none' },
      },
      component: (
        <HamburgerButton />
      ),
    },
  ]

  const features = [
    {
      icon: <NotificationsActiveTwoToneIcon />,
      title: 'Gathered Data',
      description:
        'When you search an address our software will gather data (ARV, comps, rent, ext.) from a variety of data sources for you',
      iconColor: 'text-danger',
    },
    {
      icon: <SettingsTwoToneIcon />,
      title: 'Strategies',
      description:
        'The software runs all the number to help you determine which strategy is best. Buy & Hold? Flip? Wholesale? Turnkey?',
      iconColor: 'text-warning',
      sx: {
        display: 'none',
        '@media (min-width: 768px)': { display: 'block' },
      },
    },
    {
      icon: <LocalLibraryTwoToneIcon />,
      title: 'Watch Demo Video',
      description:
        'Watch a short video covering all the features avaliable to you once you start your trial with us!',
      iconColor: 'text-success',
      sx: {
        display: 'none',
        '@media (min-width: 1100px)': { display: 'block' },
      },
    },
  ]

  return (
    <>
      <Box style={{ backgroundColor: '#070919', borderColor: '#070919' }} sx={[{ borderWidth: "2px !important", borderStyle: "solid !important" }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]}/>

      <PublicPageHeader
        logo="/images/LeftNavLogo.png"
        title="General"
        subtitle="bamburgh"
        navigation={navigation}
        actions={actions}
      />

      <Box sx={[{ background: "rgba(255, 255, 255, 0.06) !important" }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]} />

      <PublicPageHero
        backgroundImage={hero7}
        title="Housefolios Property Analysis"
        subtitle="Type in an address below to see an analysis of a property! Or create an account to see a full analysis"
        buttonText="Search for a Property"
        buttonIcon={['fas', 'arrow-right']}
        onButtonClick={toggleOpen}
        overlayOpacity={0.4}
      >
        <Container sx={[{ color: '#fff', pt: '1.5rem' }, { position: "relative", zIndex: "25" }]}>
          <Grid container spacing={6} sx={{ pt: '1.5rem' }}>
            {features.map((feature, index) => (
              <Grid size={{ md: 6, xl: 4 }} key={index}>
                <FeatureCard {...feature} />
              </Grid>
            ))}
          </Grid>
        </Container>

        <Box sx={{ zIndex: "4", position: "relative" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              fill="var(--light)"
              fillOpacity="1"
              d="M0,288L48,250.7C96,213,192,139,288,106.7C384,75,480,85,576,112C672,139,768,181,864,176C960,171,1056,117,1152,128C1248,139,1344,213,1392,250.7L1440,288L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            />
          </svg>
        </Box>
      </PublicPageHero>

      <PropertySearchDialog
        open={open}
        onClose={toggleOpen}
        onSearch={searchProperty}
        query={query}
        setQuery={setQuery}
        placeResult={placeResult}
        setPlaceResult={setPlaceResult}
        loading={loader}
      />
    </>
  )
}
